import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="bottom-center"
        toastOptions={{
          style: {
            background: "#2C2826",
            color: "#FDFBF7",
            border: "none",
            borderRadius: "0px",
            fontFamily: "Outfit, sans-serif",
            fontSize: "0.85rem",
            letterSpacing: "0.04em",
            padding: "16px 22px",
          },
        }}
      />
    </div>
  );
}

export default App;
